import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'react-i18next';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Outlet } from 'react-router-dom'
import { List } from "@mui/material";
import DrawerItem from '../DrawerItem/DrawerItem';
import usePermissionEngine from "../../../scenes/global/NewSidebar/usePermissionEngine";
import sidebarMenuData from "../../../scenes/global/NewSidebar/sidebarMenu.json";
import iconMap from "../../../scenes/global/NewSidebar/iconMap";
import { useState } from 'react';
import ThemeModeSwitcher from '../GlobalComponents/ThemeModeSwitcher/ThemeModeSwitcher';
import { LocalizateCurrentDate } from '../LocalizateCurrentDate/LocalizateCurrentDate';
import Logo from '../../General/Logo/Logo';
import { useTheme } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';


const drawerWidth = 240;

interface Props {
  window?: () => Window;
}

export default function ResponsiveDrawer(props: Props) {


  const [sidebar, setSidebar] = useState(true);
  const filteredMenu = usePermissionEngine(sidebarMenuData.menu);
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const isClosingRef = React.useRef(false);
  const [selected, setSelected] = useState('');

  const drawerPaperStyles = {
    backgroundColor: "#19686A",
    color: "#fff",
    borderRight: "none",
  };




  const handleDrawerClose = () => {
    isClosingRef.current = true;
    setMobileOpen(false);
    // safety-net: حتی اگه onTransitionEnd fire نشه، بعد از ۴۰۰ میلی‌ثانیه (بیشتر از مدت transition پیش‌فرض MUI) خودش ریست میشه
    setTimeout(() => {
      isClosingRef.current = false;
    }, 400);
  };

  const handleDrawerTransitionEnd = () => {
    isClosingRef.current = false;
  };

  const handleDrawerToggle = () => {
    if (!isClosingRef.current) {
      setMobileOpen((prev) => !prev);
    }
  };
  const theme = useTheme();


  const drawer = (
    <>
      <Toolbar >
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', p: 2, alignItems: 'center' }}   >
          <Logo />

          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon sx={{ color: 'white' }} /> : <ChevronLeftIcon sx={{ color: 'white' }} />}
          </IconButton>
        </Box>
      </Toolbar>
      <Divider />

      <List>
        {filteredMenu.map((item) => (
          <DrawerItem
            key={item.key}
            item={item}
            selected={selected}
            setSelected={setSelected}
            sidebar={sidebar}
            iconMap={iconMap}
          />
        ))}

      </List>
    </>
  );

  // Remove this const when copying and pasting into your project.
  const container = window !== undefined ? () => window().document.body : undefined;
  const { t } = useTranslation('global');

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          backgroundColor: "#19686A",
          color: "#fff",
        }}
      >
        <Toolbar >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between',alignItems:'center' }}  >
            <Typography variant="body2" noWrap component="div">
              {
                t('babakTemplateMakers')
              }
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}  >

              <Box>
                <LocalizateCurrentDate />
              </Box>
              <Box>
                <Divider variant='fullWidth' />
              </Box>
              <Box>
                <ThemeModeSwitcher />
              </Box>
            </Box>
          </Box>

        </Toolbar>


      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >

        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              ...drawerPaperStyles, // ← رنگ‌ها اینجا اعمال شد
            },
          }}
 
        >
          {drawer}
        </Drawer>

        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}
